import React from 'react';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import CSSHolographicCard from './CSSHolographicCard';

interface HolographicCardViewerProps {
  imageUrl: string;
  isGenerating?: boolean;
  className?: string;
  overlayData?: {
    author: string;
    title: string;
    serial: string;
    rarity: string;
  };
}

export const HolographicCardViewer: React.FC<HolographicCardViewerProps> = ({
  imageUrl,
  isGenerating = false,
  className,
  overlayData
}) => {
  if (isGenerating) {
    return (
      <div className="w-full aspect-[1/2] rounded-xl overflow-hidden border bg-gradient-to-br from-purple-900/20 to-blue-900/20 flex items-center justify-center">
        <div className="text-center space-y-2">
          <div className="animate-spin w-6 h-6 border-2 border-primary border-t-transparent rounded-full mx-auto"></div>
          <p className="text-sm text-muted-foreground">Generating holographic effect...</p>
        </div>
      </div>
    );
  }

  if (!imageUrl) {
    return (
      <div className="w-full aspect-[1/2] rounded-xl overflow-hidden border bg-muted flex items-center justify-center">
        <p className="text-muted-foreground text-sm">No media selected</p>
      </div>
    );
  }

  return (
    <ErrorBoundary fallback={
      <div className="w-full aspect-[1/2] rounded-xl overflow-hidden border bg-muted flex items-center justify-center">
        <p className="text-muted-foreground text-sm">Preview unavailable</p>
      </div>
    }>
      <CSSHolographicCard
        imageUrl={imageUrl}
        style="rainbow"
        intensity={0.8}
        className={className}
        overlayData={overlayData}
      />
    </ErrorBoundary>
  );
};

export default HolographicCardViewer;